export enum BreakdownPermissions {
  Create = "create:breakdown",
  Read = "read:breakdown",
  Update = "update:breakdown",
  Delete = "delete:breakdown",
}
